import { Text, TableBody, TableItem, Icon, Avatar, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { columnWidthsDesktop } from '../../constants';

import { TradingListItemTypes } from '.';

export const TradingListItemDesktop: React.FC<TradingListItemTypes.Content> = ({
  item,
  handleNavigate,
}) => {
  const handleDetails = () => {
    handleNavigate({
      currentSinacorAccount: item.contaSinacorSemDigito,
      currentAccountPNP: item.contaSuperPNPSemDigito,
      currentIdAccount: item.idConta,
      currentAccountBP: item.contaBPComDigito,
    });
  };

  return (
    <TableBody testId="table-body" spaceX="inset.sm">
      <TableItem
        align="start"
        width={columnWidthsDesktop.name}
        testId="header-id"
        onPress={handleDetails}>
        <HStack
          space={Spacing['inline.xxxs']}
          alignItems="center"
          py={Spacing['inset.xs']}
          maxW={'100%'}
          justifyContent={'space-between'}>
          <Avatar
            testId="client-avatar"
            textColor="neutral.white"
            bgColor={'brand.primary.light'}
            initials={item.initials}
          />
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            {item.nomeCliente}
          </Text>
        </HStack>
      </TableItem>

      <TableItem
        align="start"
        width={columnWidthsDesktop.email}
        testId="header-order"
        onPress={handleDetails}>
        <VStack py={Spacing['inset.xs']} maxW={'100%'} justifyContent={'space-between'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            flex={1}
            textAlign="start">
            {item.email}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={columnWidthsDesktop.personType}
        testId="header-last-update"
        onPress={handleDetails}>
        <VStack py={Spacing['inset.xs']} maxW={'100%'} justifyContent={'space-between'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Typography['fontsize.md']}
            flex={1}
            textAlign="start">
            {item.tipoPessoaNormalized}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={columnWidthsDesktop.sinacorAccount}
        testId="header-clients"
        onPress={handleDetails}>
        <VStack py={Spacing['inset.xs']} maxW={'100%'} justifyContent={'space-between'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Typography['fontsize.md']}
            flex={1}
            color="neutral.medium"
            textAlign="start">
            {item.contaSinacorComDigito}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={columnWidthsDesktop.custodyAccount}
        testId="header-assets"
        onPress={handleDetails}>
        <VStack justifyContent={'space-between'} maxW={'100%'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            alignItems={'center'}
            fontWeight={Typography['fontweight.regular']}
            fontSize={Typography['fontsize.md']}
            flex={1}
            textAlign="start">
            {item.contaSuperPNPComDigito}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={columnWidthsDesktop.accountBP}
        testId="header-clients"
        onPress={handleDetails}>
        <VStack justifyContent={'space-between'} maxW={'100%'} flex={1}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Typography['fontsize.md']}
            flex={1}
            textAlign="start">
            {item.contaBPComDigito}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={columnWidthsDesktop.action}
        testId="header-actions"
        onPress={handleDetails}>
        <HStack alignItems="center">
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.semibold']}
            fontSize={Typography['fontsize.md']}
            flex={1}
            color={'brand.tertiary.principal'}
            textAlign="start">
            DETALHES
          </Text>

          <Icon
            name="ChevronRight"
            color={Color['brand.tertiary.principal']}
            testId="action-button"
            size="sm"
          />
        </HStack>
      </TableItem>
    </TableBody>
  );
};
